const ACTION_TYPE = "ORDERS";
export const GET_ORDERS_FAIL = `${ACTION_TYPE}/GET_ORDERS_FAIL`;
export const GET_ORDERS_SUCCESS = `${ACTION_TYPE}/GET_ORDERS_SUCCESS`;

export const GET_SINGLE_ORDER_FAIL = `${ACTION_TYPE}/GET_SINGLE_ORDER_FAIL`;
export const GET_SINGLE_ORDER_SUCCESS = `${ACTION_TYPE}/GET_SINGLE_ORDER_SUCCESS`;

export const CHANGE_STATUS_FAIL = `${ACTION_TYPE}/CHANGE_STATUS_FAIL`;
export const CHANGE_STATUS_SUCCESS = `${ACTION_TYPE}/CHANGE_STATUS_SUCCESS`;
